import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const useApi = (url, opts = {}) =>
  useQuery({
    queryKey: [url], queryFn: () => api.get(url).then((r) => r.data), staleTime: 0,
    retry: (n, e) => !(e?.response?.status >= 400 && e?.response?.status < 500) && n < 2, ...opts,
  });

export const useRefresh = () => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries();
};

export const errMsg = (e) => e?.response?.data?.detail || "Si è verificato un errore";
